// Line-height
/**
 * line-height: 16px
 */
export const LINE_HEIGHT_1 = '1rem';
/**
 * line-height: 20px
 */
export const LINE_HEIGHT_2 = '1.25rem';
/**
 * line-height: 24px
 */
export const LINE_HEIGHT_3 = '1.5rem';
/**
 * line-height: 32px
 */
export const LINE_HEIGHT_4 = '2rem';
/**
 * line-height: 40px
 */
export const LINE_HEIGHT_5 = '2.5rem';
/**
 * line-height: 48px
 */
export const LINE_HEIGHT_6 = '3rem';

// Letter spacing
/**
 * letter-spacing: -0.5px
 */
export const LETTER_SPACING_DENSEST = '-0.03125rem';
/**
 * letter-spacing: -0.2px
 */
export const LETTER_SPACING_DENSE = '-0.0125rem';
/**
 * letter-spacing: 0px
 */
export const LETTER_SPACING_DEFAULT = '0';
/**
 * letter-spacing: 0.7px
 */
export const LETTER_SPACING_EXPANDED_1 = '0.04375rem';
/**
 * letter-spacing: 0.91px
 */
export const LETTER_SPACING_EXPANDED_2 = '0.056875rem';
/**
 * letter-spacing: 1px
 */
export const LETTER_SPACING_EXPANDED_3 = '0.0625rem';

// Font size
/**
 * font-size: 8px
 */
export const FONT_SIZE_8 = '0.5rem';
/**
 * font-size: 9px
 */
export const FONT_SIZE_9 = '0.5625rem';
/**
 * font-size: 10px
 */
export const FONT_SIZE_10 = '0.625rem';
/**
 * font-size: 11px
 */
export const FONT_SIZE_11 = '0.6875rem';
/**
 * font-size: 12px
 */
export const FONT_SIZE_12 = '0.75rem';
/**
 * font-size: 13px
 */
export const FONT_SIZE_13 = '0.8125rem';
/**
 * font-size: 14px
 */
export const FONT_SIZE_14 = '0.875rem';
/**
 * font-size: 16px
 */
export const FONT_SIZE_16 = '1rem';
/**
 * font-size: 18px
 */
export const FONT_SIZE_18 = '1.125rem';
/**
 * font-size: 20px
 */
export const FONT_SIZE_20 = '1.25rem';
/**
 * font-size: 24px
 */
export const FONT_SIZE_24 = '1.5rem';
/**
 * font-size: 28px
 */
export const FONT_SIZE_28 = '1.8rem';
/**
 * font-size: 32px
 */
export const FONT_SIZE_32 = '2rem';
/**
 * font-size: 40px
 */
export const FONT_SIZE_40 = '2.5rem';
/**
 * font-size: 44px
 */
export const FONT_SIZE_44 = '2.75rem';

// Font weight
/**
 * Font-weight: 700
 */
export const FONT_WEIGHT_BOLDER = 700;
/**
 * Font-weight: 800
 */
export const FONT_WEIGHT_BOLDEST = 800;

// Font family
export const FONT_FAMILY =
  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

/*
 * @figma-tokens:begin
 */
/**
 * Font-weight: 500
 */
export const FONT_WEIGHT_MEDIUM = 'var(--font-weight-medium)';
/**
 * Font-weight: 400
 */
export const FONT_WEIGHT_REGULAR = 'var(--font-weight-regular)';
/**
 * Font-weight: 600
 */
export const FONT_WEIGHT_SEMIBOLD = 'var(--font-weight-semibold)';
export const FONT_FAMILY_BASE = 'var(--font-family-base)';
/*
 * @figma-tokens:end
 */
